import { DayOffTemplate } from '@gooduncles/gu-app-schema';
import { FC } from 'react';

import classes from '../../KakaoAlimtalkSend.module.scss';

const templateText = `#{date}는 가락시장 휴장으로 #{products} 상품 배송이 불가합니다.

📢 필요한 상품은 반드시 #{until} 이전까지 주문해 주세요.

⛔ 배송 불가 상품 ⛔

#{category01}
#{category02}

※ #{inform}은 물량 폭주로 평소 보다 배송이 지연됩니다.`;

const replaceTemplateVariables = (template: string, params: Partial<DayOffTemplate>): string => {
  return template.replace(/#{(\w+)}/g, (match, key) => {
    const value = params[key as keyof DayOffTemplate];
    return value != null ? value : match;
  });
};

interface DayOffAlimtalkPreviewProps {
  templateParams: Partial<DayOffTemplate>;
}

const DayOffAlimtalkPreview: FC<DayOffAlimtalkPreviewProps> = ({ templateParams }) => {
  const previewText = replaceTemplateVariables(templateText, templateParams);

  return (
    <div className={classes.previewContainer}>
      <div className={classes.previewWhiteBoard}>
        <p className={classes.previewText}>{previewText}</p>
        <a
          className={classes.previewButton}
          href={templateParams.mobile ? `https://${templateParams.mobile}` : undefined}
          target='_blank'
          rel='noopener noreferrer'
          style={{ textDecoration: 'none', pointerEvents: templateParams.mobile ? 'auto' : 'none' }}
        >
          <span>상세 내용</span>
        </a>
      </div>
    </div>
  );
};

export default DayOffAlimtalkPreview;
